import React from 'react';
import LandingPageTop from './LandingPageTop';
import LandingPageTopTwo from './LandingPageTopTwo';
import LandingPageSocial from './LandingPageSocial';
import TopFooter from './TopFooter';

function LandingPage() {

    return (
        <div>
            <LandingPageTop />
            <LandingPageTopTwo />
            <LandingPageSocial />
            <TopFooter />
        </div>
    );
}

export default LandingPage;
